import React from 'react';
import { motion } from 'framer-motion';
import { PageHeader } from './components/PageHeader';
import { TermsSection } from './components/TermsSection';
import { ContactSection } from '@/components/shared/ContactSection';
import { termsContent } from './termsContent';

export function TermsOfServicePage() {
  return (
    <div className="pt-32 pb-16 px-4">
      <motion.div 
        className="max-w-4xl mx-auto prose prose-lg"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        <PageHeader 
          title="Terms of Service" 
          lastUpdated="October 6 2024" 
        />
        
        {termsContent.map((section, index) => (
          <TermsSection 
            key={index}
            title={section.title}
            content={section.content}
            index={section.index}
          />
        ))}

        <ContactSection 
          email="info@convertology.ai"
          company="Convertology.ai"
        />
      </motion.div>
    </div>
  );
}